import { Directive, ViewContainerRef } from '@angular/core';

@Directive(
    {
        selector: "[view-ref]"
    }
)
export class ViewRefDirective
{
    public viewContainerRef: ViewContainerRef;

    public constructor(viewContainerRef: ViewContainerRef)
    {
        this.viewContainerRef = viewContainerRef;
    }
}
